import Vue from 'vue';

function filters() {
	return {
		/*period: null,*/
		cat_office_id: null,
		cat_acquisition_type_id: null,
		sub_budget_id: null,
		product_or_service_id: null,
		checkList: []
	}
}

function graphicData() {
	return {
		/*labels: [],*/
		/*datasets: [
			{
				label: 'Total de solicitudes',
				borderColor: 'blue',
				pointBackgroundColor: 'white',
				pointBorderColor: 'white',
				borderWidth: 2,
				data: [60]
	        }
		]*/
	}
}


const state = {
	model: filters(),
	chart: graphicData(),
	catalogs: {
		catOffice: [],
		catAcquisitionType : [],
		catSubBudget: [],
		catPeriods: [],
		catProductsOrServicesArticles: []
	},
};

const mutations = {
	clear(state) {
		state.model = filters();
		state.chart = graphicData();
		state.catalogs = {
				catOffice: [],
				catAcquisitionType : [],
				catSubBudget: [],
				catPeriods: [],
				catProductsOrServicesArticles: []
		};
	},
	loadCatalogSuccess(state, response) {
		const {data} = response;
		state.catalogs = data;

	},

};

const actions = {
	loadCatalog({state, commit, dispatch}, payload) {

		let url = '/api/acquisitions/catalogs';

		return window.axios.get(`${url}`, {params: null})

			.then((res) => {
				const parsedResponse = res.data;
				if (parsedResponse) {
					commit('loadCatalogSuccess', parsedResponse);
					return parsedResponse;
				} else {
					return Promise.reject(parsedResponse);
				}
			})
			.catch((err) => {
				dispatch('loading/spinner', {}, {root: true});
				let msg = 'No se pudo completar la acción';
				if (err.response &&
					err.response.data &&
					err.response.data.message
					&& err.response.status == 400) {
					msg = err.response.data.message;
				}
				dispatch('notifications/error', {msg: msg}, {root: true});
				return Promise.reject(err);
			});
	},
	initService({commit, dispatch}, payload) {
		let array_dispatch = [];
		array_dispatch.push(dispatch('loadCatalog'));

		dispatch('loading/spinner', {msg: 'Cargando Datos...', status: true}, {root: true});



		return Promise.all(array_dispatch)
			.then(() => {
				dispatch('loading/spinner', {}, {root: true});
			})
			.catch((err) => {
				dispatch('loading/spinner', {}, {root: true});
				let msg = 'No se pudo completar la acción';
				if (err.response &&
					err.response.data &&
					err.response.data.message
					&& err.response.status == 400) {
					msg = err.response.data.message;
				}
				dispatch('notifications/error', {msg: msg}, {root: true});
				return Promise.reject(err);
			});
	},
};

const getters = {
	requestFilters: state => state.model,
	chartData: state => state.chart,
	catalogs: state => state.catalogs,
	general: state => state,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};

